import { MessageSquareText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button, EmptyState } from '@/components/ui';
import type { PanelReceivableFollowUp } from './api';
import styles from './PanelReceivables.module.css';

const date = new Intl.DateTimeFormat('en-MY', { dateStyle: 'medium' });
const dateTime = new Intl.DateTimeFormat('en-MY', {
  dateStyle: 'medium',
  timeStyle: 'short',
});

export function FollowUpActivityLog({
  entries,
  canManage,
  onLog,
}: {
  entries: PanelReceivableFollowUp[];
  canManage: boolean;
  onLog: () => void;
}) {
  const { t } = useTranslation();

  return (
    <section className={styles.activitySection}>
      <div className={styles.sectionHeading}>
        <h3>{t('panelReceivables.followUpLog')}</h3>
        {canManage && (
          <Button size="sm" variant="primary" onClick={onLog}>
            {t('panelReceivables.logFollowUp')}
          </Button>
        )}
      </div>
      {entries.length === 0 ? (
        <EmptyState
          icon={<MessageSquareText size={22} />}
          title={t('panelReceivables.noFollowUps')}
          body={t('panelReceivables.noFollowUpsBody')}
        />
      ) : (
        <ol className={styles.activityList}>
          {entries.map((entry) => (
            <li key={entry.id}>
              <div className={styles.activityMeta}>
                <strong>{entry.createdByName}</strong>
                <time dateTime={entry.createdAt}>
                  {dateTime.format(new Date(entry.createdAt))}
                </time>
              </div>
              <p>{entry.note}</p>
              <dl className={styles.followUpFacts}>
                <div>
                  <dt>{t('panelReceivables.followUpDate')}</dt>
                  <dd>{date.format(new Date(entry.date))}</dd>
                </div>
                <div>
                  <dt>{t('panelReceivables.channel')}</dt>
                  <dd>{entry.channel}</dd>
                </div>
                {entry.nextDate && (
                  <div>
                    <dt>{t('panelReceivables.nextFollowUp')}</dt>
                    <dd>{date.format(new Date(entry.nextDate))}</dd>
                  </div>
                )}
              </dl>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
